export default __webpack_public_path__ + "static/media/BharatFull.859a5276.webp";